import { render } from "./Combo.vue?vue&type=template&id=b2bd0060"
import script from "./Combo.vue?vue&type=script&lang=js"
export * from "./Combo.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__